// weekly events
export const CREATE_USER_EVENT_REQUEST = 'CREATE_USER_EVENT_REQUEST'
export const CREATE_USER_EVENT_SUCCESS = 'CREATE_USER_EVENT_SUCCESS'
export const CREATE_USER_EVENT_FAILURE = 'CREATE_USER_EVENT_FAILURE'
export const GET_USER_EVENTS_REQUEST = 'GET_USER_EVENTS_REQUEST'
export const GET_USER_EVENTS_SUCCESS = 'GET_USER_EVENTS_SUCCESS'
export const GET_USER_EVENTS_FAILURE = 'GET_USER_EVENTS_FAILURE'
export const DELETE_USER_EVENT_REQUEST = 'DELETE_USER_EVENT_REQUEST'
export const DELETE_USER_EVENT_SUCCESS = 'DELETE_USER_EVENT_SUCCESS'
export const DELETE_USER_EVENT_FAILURE = 'DELETE_USER_EVENT_FAILURE'
export const UPDATE_USER_EVENT_REQUEST = 'UPDATE_USER_EVENT_REQUEST'
export const UPDATE_USER_EVENT_SUCCESS = 'UPDATE_USER_EVENT_SUCCESS'
export const UPDATE_USER_EVENT_FAILURE = 'UPDATE_USER_EVENT_FAILURE'
export const RESET_USER_EVENTS_REQUEST = 'RESET_USER_EVENTS_REQUEST'
